class MainMenuService {
    constructor ($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
      this.$q = $q;
      this.$http = $http;
      this.ngAuthSettings = ngAuthSettings;
      this.$httpParamSerializerJQLike= $httpParamSerializerJQLike;
    }
    

  }
  
  MainMenuService.$inject = ['$q','$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];
  
  export default MainMenuService;
  


/** WEBPACK FOOTER **
 ** ./www/components/main-menu/main-menu.service.js
 **/